import styles from "./index.module.scss";

export const Loader = () => {
  return (
    <div className={[styles.loading, styles.loading06].join(" ")}>
      <span data-text="S">S</span>
      <span data-text="I">I</span>
      <span data-text="L">L</span>
      <span data-text="E">E</span>
      <span data-text="N">N</span>
      <span data-text="C">C</span>
      <span data-text="I">I</span>
      <span data-text="0">O</span>
    </div>
  );
};
